import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
    PrevYearSpeakers:[],
    message:'',
    isLoading:false,
    isError:false,
    isSuccess:false,
}


////////////////////////////Get All PrevYearSpeakers////////////////
export const GetAllPrevYearSpeakers = createAsyncThunk('Speaker/GetAllPrevYearSpeakers', async(_, thunkAPI)=>{
    try{
        const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/getAllPrevDashboardSpeaker`
        const response = await axios.get(API_URL) 
        return response.data
 
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})



export const CreatePrevYearSingleSpeaker = createAsyncThunk('Speaker/CreatePrevYearSingleSpeaker', async(data, thunkAPI)=>{

    try{
        const token = thunkAPI.getState().auth.user.token
        const config ={
           headers:{
               Authorization: `Bearer ${token}`
           }
       }
        const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/createPrevDashboardSpeaker`
        const response = await axios.post(API_URL, data,config)
        return response.data
 
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})


export const DeletePrevYearSingleSpeaker = createAsyncThunk('Speaker/DeletePrevYearSingleSpeaker', async(id, thunkAPI)=>{

    try{
        const token = thunkAPI.getState().auth.user.token
        const config ={
           headers:{
               Authorization: `Bearer ${token}`
           }
       }
        const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/deleteSinglePrevDashboardSpeaker/${id}`
        const response = await axios.delete(API_URL,config)
        return response.data
 
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})



export const PrevYearSpeakerslice = createSlice({
    name:'PrevYearSpeakerslice',
    initialState,
    reducers:{
        reset: (state)=> initialState,
        filterState:(state,action)=>{            
            state.PrevYearSpeakers = state.PrevYearSpeakers.filter((item) => item._id !== action.payload)
        }
    },
    extraReducers:(builder)=>{
        builder
        .addCase(GetAllPrevYearSpeakers.pending, (state, action)=>{
            state.isLoading = true
        })
        .addCase(GetAllPrevYearSpeakers.fulfilled, (state, action)=>{
            state.isLoading = false
            state.message = action.payload.message
            if(action.payload.success===true){
                const RequiredData = action.payload.AllDashboardSpeaker.map((listing,index) => ({
                    ...listing,
                    id: index+1,
                  }));
            state.PrevYearSpeakers = RequiredData
            }
        })
        .addCase(GetAllPrevYearSpeakers.rejected, (state, action)=>{
            state.isLoading = false
            state.isError=true
            state.message = action.payload
            state.PrevYearSpeakers={_id:"",name:"",designation:"",company:"",linkedIn:"",speakerImgDash:""}
        })


        .addCase(CreatePrevYearSingleSpeaker.pending, (state, action)=>{
            state.isLoading = true
        })
        .addCase(CreatePrevYearSingleSpeaker.fulfilled, (state, action)=>{
            state.isLoading = false
            state.message = action.payload.message
            toast(action.payload.message)         
        })
        .addCase(CreatePrevYearSingleSpeaker.rejected, (state, action)=>{
            state.isLoading = false
            state.isError=true
            state.message = action.payload
            toast(action.payload)
        })

        .addCase(DeletePrevYearSingleSpeaker.pending, (state, action)=>{
            state.isLoading = true
        })
        .addCase(DeletePrevYearSingleSpeaker.fulfilled, (state, action)=>{
            state.isLoading = false
            state.message = action.payload.message
            toast(action.payload.message)
            
        })
        .addCase(DeletePrevYearSingleSpeaker.rejected, (state, action)=>{
            state.isLoading = false
            state.isError=true
            state.message = action.payload
            toast(action.payload)
        })

    }
})


export const {reset,filterState} = PrevYearSpeakerslice.actions
export default PrevYearSpeakerslice.reducer